'use es6';

import { getDefinition } from 'FormsUI/selectors/FormDefinition';
import { getFormattedDefinition } from 'FormsUI/utils/FormSavingUtils';
import { getFormPreviewPageStep } from 'FormsUI/selectors/FormPreview';
const postMessageMiddleware = eventBus => store => next => action => {
  const result = next(action);
  const nextState = store.getState();
  const form = getDefinition(nextState);
  const formattedDefinition = getFormattedDefinition('', form);
  const formPageStep = getFormPreviewPageStep(nextState);
  if (eventBus && form) {
    eventBus.postMessage({
      type: 'SYNC_PREVIEW',
      payload: {
        // TODO: Add gates and scopes
        form: JSON.parse(JSON.stringify(Object.assign({}, formattedDefinition, {
          updatedAt: 0,
          createdAt: 0,
          internalUpdatedAt: 0
        }))),
        meta: {
          formPageStep
        }
      }
    });
  }
  return result;
};
export default postMessageMiddleware;